import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 45243722-DE4F-4339-878C-4990A62A1990
 * name audio-input-stereo-minijack
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/audio-input-stereo-minijack.svg
 * tags
 * - Audio 
 */
export const AudioInputStereoMinijackIcon = createSvgIcon(<><path d="M11 4V3C11 2.45 11.45 2 12 2S13 2.45 13 3V4H11M13 9V5H11V9H9V15C9 16.3 9.84 17.4 11 17.82V22H13V17.82C14.16 17.4 15 16.3 15 15V9H13Z" /></>, 'AudioInputStereoMinijackIcon');
export default AudioInputStereoMinijackIcon